import AccountNotice from "./AccountNotice";

export default AccountNotice;
